export default __webpack_public_path__ + "static/media/dino_HAPPY.1b21bc10.png";